export default "__VITE_ASSET__DpUMyi_F__"